import type { ProjectType } from '@atlassian/jira-common-constants/src/index.tsx';
import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import type { State as ReduxState } from '@atlassian/jira-issue-view-common-types/src/issue-type.tsx';
import { useSelector } from '@atlassian/jira-react-redux/src/index.tsx';

const SUPPORTED_CO_USE_PROJECT_TYPES: ProjectType[] = [CORE_PROJECT, SOFTWARE_PROJECT];

const SUPPORTED_LOADING_BLANKET_PROJECT_TYPES: ProjectType[] = [
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
];

// Hook to be used in src/packages/issue/issue-view-base/src/content/loom-videos/ui/main.tsx
// Should be moved to a new issue-view-loom-videos package when cleaning up this experiment
export const useLoomSupportedProjectType = () => {
	const project = useSelector((state: ReduxState) => state.entities?.project);
	const projectType = project?.projectType;

	const showCoUsePanel = projectType && SUPPORTED_CO_USE_PROJECT_TYPES.includes(projectType);
	const showLoadingBlanket =
		projectType && SUPPORTED_LOADING_BLANKET_PROJECT_TYPES.includes(projectType);
	return {
		showCoUsePanel,
		showLoadingBlanket,
	};
};
